import { gql } from '@apollo/client';

import { AnswerFragment } from 'approot/activity-builder/present/activity-answers.graphql';

export const GET_TEACHER_ANSWER_BY_ID = gql`
  query GetTeacherAnswerById($input: GetTeacherAnswerByIdInput!) {
    getTeacherAnswerById(input: $input) {
      ...AnswerFragment
    }
  }
  ${AnswerFragment}
`;
